// Supabase Client Configuration
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://rzsienyvlpcenitumhnj.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ6c2llbnl2bHBjZW5pdHVtaG5qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYyMTQyOTcsImV4cCI6MjA4MTc5MDI5N30.XFLJiC4_HwQv8-Vr2-eFK9YV5YeKo7o8nTBcUPwVFQE';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
